import React from "react";

const TakeoverOffer = () => {
  return <div>TakeoverOffer</div>;
};

export default TakeoverOffer;
